import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { BsLayers } from 'react-icons/bs';

let GrupoAPEButton = (props) => {
    return (
        <Tooltip title={`APE ${props.grupo}`}>
            <IconButton
                aria-label="Add"
            >
                <BsLayers />
            </IconButton>
        </Tooltip>
    );
}

export default GrupoAPEButton;

  

